import {
  ArrowBack,
  ArrowForward,
  CurrencyRupeeSharp,
  Shortcut,
} from "@mui/icons-material";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import NoDataFound from "../../CustomComponents/NoDataFound";
import { useDispatch } from "react-redux";
import { DisbursementBalanceTransferReducerAction } from "../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import GetBranchDetailsWithCode from "../../CustomComponents/GetBranchDetailsWithCode";
import ConvertBase64ToFile from "../../CustomComponents/ConvertBase64ToFile";

const SanctionedList = (props) => {
  const columns = [
    {
      field: "branch",
      headerName: "Branch Name",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
    },

    {
      field: "customerName",
      headerName: "Applicant Name",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
      sortable: false,
    },
    // {
    //   field: "customerType",
    //   headerName: "Customer Type",
    //   headerAlign: "center",
    //   type: "string",
    //   flex: 130,
    //   align: "left",
    //   sortable: false,
    // },
    {
      field: "loanType",
      headerName: "Loan Type",
      headerAlign: "center",
      type: "string",
      flex: 130,
      align: "left",
      sortable: false,
    },
    {
      field: "applicationNum",
      headerName: "Application Number",
      headerAlign: "center",
      type: "string",
      hideable: false,
      flex: 194,
      align: "left",
    },
    {
      field: "applicationDate",
      headerName: "Application Date",
      headerAlign: "center",
      type: "string",
      flex: 140,
      align: "right",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        var date = new Date(params.value);
        return (
          <Typography sx={{ display: "flex", alignItems: "center" }}>
            {dayjs(date).format("DD/MM/YYYY")}
          </Typography>
        );
      },
    },
    {
      field: "sanctionAmt",
      headerName: "Sanctioned Amount",
      headerAlign: "center",
      type: "string",
      flex: 190,
      align: "right",
      sortable: false,
      renderHeader: (params) => {
        return (
          <>
            {"Sanctioned Amount("} <CurrencyRupeeSharp fontSize="small" /> {")"}
          </>
        );
      },
      renderCell: (params) => {
        return params.value.toLocaleString("en-IN");
      },
    },
    {
      field: "tenure",
      headerName: "Tenure",
      headerAlign: "center",
      type: "string",
      flex: 90,
      align: "right",
      sortable: false,
    },
    {
      field: "losStatus",
      headerName: "Status",
      headerAlign: "center",
      type: "string",
      flex: 200,
      align: "left",
      sortable: false,
      renderCell: (params) => {
        return loadStatus(params.value);
      },
    },
  ];

  // max value 1200 -> mobile.
  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  const [deviceMode, setDeviceMode] = React.useState(
    deviceModeValue ? "MOBILE" : "DESKTOP"
  );

  const [page, setPage] = React.useState(deviceModeValue ? 1 : 0);
  const [rows, setRows] = React.useState([]);
  const [totalDataRows, setTotalDataRows] = React.useState([]);
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const [totalRecordsCount, setTotalRecordsCount] = React.useState(0);
  const rowsPerPage = 20;
  const navigate = useNavigate();
  const [filterConditionStateValue, setFilterConditionStateValue] =
    React.useState({});
  const [loading, setLoading] = React.useState(true);
  //using dispatch
  const dispatchRedux = useDispatch();

  useEffect(() => {
    setFilterConditionStateValue(props.filterConditionState);
    setPage(deviceModeValue ? 1 : 0);
    setLoading(true);
    async function getSanctionListData() {
      let filterCondition = {};
      let filterConditionStateData = { ...props.filterConditionState };
      createFilterCondition(filterCondition, filterConditionStateData);
      // when branch is single & empty -> trigger all the branches.
      filterCondition.branch =
        filterCondition.branch.length === 1 &&
        filterCondition.branch[0] !== null &&
        filterCondition.branch[0] !== undefined &&
        filterCondition.branch[0] !== ""
          ? filterCondition.branch
          : filterConditionStateData.branchNames.map((name) => name.label);
      filterCondition.offset = 0;
      filterCondition.pageSize = rowsPerPage;
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const response = await axios.post(
        "/losCustomer/getCustomerDataWithPage",
        filterCondition
      );
      const totalrecords = [...response.data.content];
      setTotalRecordsCount(response.data.totalElements);
      setTotalPageCount(response.data.totalPages);
      setRows([...totalrecords]);
      setTotalDataRows([...totalrecords]);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
    getSanctionListData();
  }, [props.data]);

  const rowDoubleClickHandler = (event) => {
    checkNavigationToCreateOrView(event.row);
  };

  const checkNavigationToCreateOrView = async (row) => {
    const rowStatus = row.losStatus;
    if (
      rowStatus !== "Requested" &&
      rowStatus !== "Disbursement Completed" &&
      rowStatus !== "Loan Closed"
    ) {
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateLoanType(row.loanType)
      );
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
      props.onRowDoubleClick(row);
    } else {
      const disbRecordResponse = await axios.post(
        "/disbursement/getLatestDisbByAppNumAndDisbCycleNum",
        {
          applicationNum: row.applicationNum,
        }
      );
      let dataValue = { ...disbRecordResponse.data };
      dataValue.fromSancationListPage = true;
      // change the structure of the balance transfer grid.
      let balanceTransferRecords = dataValue.disbursementFavours;
      balanceTransferRecords = [...balanceTransferRecords].map((row) => {
        let record = { ...row };
        record.id = record.disbAccountKey;
        record.amount = record.totalDisbAmt;
        record.disbAmt = record.disbAmt;
        record.favouringName = record.accHoldrName;
        record.bankBranchShflBank = record.bankBranch;
        if (record.docName && record.docData) {
          record.handOverFile = record.docName;
          const arrayFileString = String(record.docData).split(";base64,");
          const base64StringValue = arrayFileString[1];
          const fileType = arrayFileString[0].split("data:");
          const uploadedFile = ConvertBase64ToFile(
            base64StringValue,
            record.docName,
            fileType[1]
          );
          const fileData = Object.assign(uploadedFile, {
            preview: URL.createObjectURL(uploadedFile),
          });
          record.handOverFiles = [fileData];
        } else {
          record.handOverFile = null;
          record.handOverFiles = [];
        }
        return record;
      });
      dataValue.disbursementFavours = balanceTransferRecords;

      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateGridRows(
          balanceTransferRecords
        )
      );
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateLoanType(
          dataValue.loanType
        )
      );
      dispatchRedux(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          null
        )
      );
      navigate("/stlap/home/disbursementView", {
        replace: true,
        state: dataValue,
      });
    }
  };

  const cardButtonClickHandler = (row) => {
    checkNavigationToCreateOrView(row);
  };

  const handlePageChange = async (event, newPage) => {
    setPage(newPage);
    let filterCondition = {};
    createFilterCondition(filterCondition, filterConditionStateValue);
    filterCondition.offset = Math.floor(
      [...totalDataRows].length / rowsPerPage
    );
    filterCondition.pageSize = rowsPerPage;
    // when branch is single & empty -> trigger all the branches.
    filterCondition.branch =
      filterCondition.branch.length === 1 &&
      filterCondition.branch[0] !== null &&
      filterCondition.branch[0] !== undefined &&
      filterCondition.branch[0] !== ""
        ? filterCondition.branch
        : filterConditionStateValue.branchNames.map((name) => name.label);
    if ([...totalDataRows].length < totalRecordsCount) {
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const response = await axios.post(
        "/losCustomer/getCustomerDataWithPage",
        filterCondition
      );
      setTotalRecordsCount(response.data.totalElements);
      setTotalPageCount(response.data.totalPages);
      const totalrecords = [...totalDataRows].concat(response.data.content);
      let offset = (newPage - 1) * rowsPerPage;
      setTotalDataRows(totalrecords);
      setRows([...totalrecords].slice(offset, offset + rowsPerPage));
    } else {
      let offset = (newPage - 1) * rowsPerPage;
      setTotalDataRows(totalDataRows);
      setRows([...totalDataRows].slice(offset, offset + rowsPerPage));
    }
  };

  const gridLazyLoad = async (newPage) => {
    if (newPage >= page) {
      setPage(newPage);
      let filterCondition = {};
      let filterConditionStateData = { ...filterConditionStateValue };
      createFilterCondition(filterCondition, filterConditionStateData);
      filterCondition.offset = Math.floor([...rows].length / rowsPerPage);
      filterCondition.pageSize = rowsPerPage;
      filterCondition.column =
        filterConditionStateData.sortConditions.length > 0
          ? filterConditionStateData.sortConditions[0].field
          : null;
      filterCondition.sort =
        filterConditionStateData.sortConditions.length > 0
          ? filterConditionStateData.sortConditions[0].sort
          : null;
      // when branch is single & empty -> trigger all the branches.
      filterCondition.branch =
        filterCondition.branch.length === 1 &&
        filterCondition.branch[0] !== null &&
        filterCondition.branch[0] !== undefined &&
        filterCondition.branch[0] !== ""
          ? filterCondition.branch
          : filterConditionStateValue.branchNames.map((name) => name.label);
      if ([...rows].length < totalRecordsCount) {
        const branchValues = [...filterCondition.branch];
        const branchCodes = getSelectedBranchCodes(branchValues);
        filterCondition.branchCode = branchCodes;
        const response = await axios.post(
          "/losCustomer/getCustomerDataWithPage",
          filterCondition
        );
        const totalrecords = [...rows].concat(response.data.content);
        setTotalRecordsCount(response.data.totalElements);
        setTotalPageCount(response.data.totalPages);
        setRows([...totalrecords]);
        setTotalDataRows([...totalrecords]);
      }
    }
  };

  const getSelectedBranchCodes = (branchValues) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValues = branchWithCodes
      .filter((branch) => branchValues.includes(branch.label))
      .map((branch) => branch.code);
    return branchCodeValues;
  };

  const onSortModelChange = async (event) => {
    if (event.length > 0) {
      setRows([]);
      setTotalDataRows([]);
      totalDataRows.length = 0;
      // rows.length = 0;
      // before response reset the rows also to empty.
      setPage(deviceMode === "MOBILE" ? 1 : 0);
      let filterCondition = {};
      createFilterCondition(filterCondition, filterConditionStateValue);
      filterCondition.offset = Math.floor(
        [...totalDataRows].length / rowsPerPage
      );
      filterCondition.pageSize = rowsPerPage;
      filterCondition.column = event[0].field;
      filterCondition.sort = String(event[0].sort).toUpperCase();
      filterConditionStateValue.sortConditions = event;
      // when branch is single & empty -> trigger all the branches.
      filterCondition.branch =
        filterCondition.branch.length === 1 &&
        filterCondition.branch[0] !== null &&
        filterCondition.branch[0] !== undefined &&
        filterCondition.branch[0] !== ""
          ? filterCondition.branch
          : filterConditionStateValue.branchNames.map((name) => name.label);
      setFilterConditionStateValue({ ...filterConditionStateValue });
      const branchValues = [...filterCondition.branch];
      const branchCodes = getSelectedBranchCodes(branchValues);
      filterCondition.branchCode = branchCodes;
      const response = await axios.post(
        "/losCustomer/getCustomerDataWithPage",
        filterCondition
      );
      const totalrecords = [...response.data.content];
      setTotalRecordsCount(response.data.totalElements);
      setTotalPageCount(response.data.totalPages);
      setRows([...totalrecords]);
      setTotalDataRows([...totalrecords]);
    }
  };

  const createFilterCondition = (filterCondition, filterConditionStateData) => {
    filterCondition.applicationNum = filterConditionStateData.applicationNum;
    filterCondition.branch = [
      filterConditionStateData.branchNames.length === 1
        ? filterConditionStateData.branchNames.at(0).label
        : filterConditionStateData.branch,
    ];
    // on single default branch add that value.
    filterConditionStateData.branch =
      filterConditionStateData.branchNames.length === 1
        ? filterConditionStateData.branchNames.at(0).label
        : filterConditionStateData.branch;
    filterCondition.applicantName = filterConditionStateData.customerName;
    filterCondition.sanctionAmt = filterConditionStateData.sanctionAmt;
    filterCondition.applicationDate = filterConditionStateData.applicationDate;
  };

  const loadStatus = (value) => {
    return (
      <Chip
        label={value}
        component="div"
        sx={{
          color:
            value === "Disbursement Completed"
              ? "white"
              : value === "Requested"
              ? "darkgreen"
              : value === "Disbursed"
              ? "darkgreen"
              : value === "Loan Closed"
              ? "white"
              : "#004A92",
          bgcolor:
            value === "Disbursement Completed"
              ? "darkgreen"
              : value === "Requested"
              ? "lightsalmon"
              : value === "Disbursed"
              ? "lightgreen"
              : value === "Loan Closed"
              ? "darkgreen"
              : "lightskyblue",
          width: "90%",
        }}
      />
    );
  };

  return (
    <>
      {useMediaQuery("(min-width:1200px)") && (
        <React.Fragment>
          {loading && (
            <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
              <Skeleton
                variant="rounded"
                animation="wave"
                width="100%"
                height={
                  window.innerHeight > 650 ? window.innerHeight / 1.8 : "260px"
                }
              />
            </Box>
          )}
          {!loading && (
            <CustomDataGrid
              noDataMessage="No Sanctioned Data."
              noDataOnFilterMessage="No Sanctioned Data on Applied Filter."
              rows={rows}
              columns={columns}
              loading={loading}
              pageSize={10}
              pageSizeOptions={[10]}
              rowHeight={40}
              pageValue={page}
              rowDoubleClickHandler={rowDoubleClickHandler}
              gridLazyLoad={gridLazyLoad}
              getRowId={(row) => row.applicationNum}
              sortingMode="server"
              onSortModelChange={onSortModelChange}
            />
          )}
        </React.Fragment>
      )}
      {useMediaQuery("(max-width:1200px)") && (
        <React.Fragment>
          <Grid
            container
            item
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-end"
            sx={{ height: "60px", bgcolor: "white" }}
          >
            {totalRecordsCount > 10 && (
              <Typography
                sx={{
                  mr: 2,
                  color: "#004A92",
                  fontWeight: 700,
                }}
              >
                {"Page Max Records : " + rowsPerPage}
              </Typography>
            )}
            <Typography
              padding="1px"
              sx={{ color: "#004A92", fontWeight: 700 }}
            >
              {"Total Records : " + totalRecordsCount}
            </Typography>
            <Pagination
              count={totalPageCount}
              color="primary"
              onChange={handlePageChange}
              page={page}
              renderItem={(item) => (
                <PaginationItem
                  slots={{ previous: ArrowBack, next: ArrowForward }}
                  {...item}
                />
              )}
            />
          </Grid>
          <Grid container>
            <Box
              sx={{
                height: props.accordianOpenState
                  ? window.innerHeight - 600
                  : window.innerHeight - 250,
                overflow: "auto",
                flex: "1 auto",
              }}
            >
              {rows.map((row, index) => (
                <React.Fragment>
                  <Grid container direction="column" sx={{ flex: "1 auto" }}>
                    <Card>
                      <CardHeader
                        action={
                          <IconButton
                            onClick={() => {
                              cardButtonClickHandler(row);
                            }}
                          >
                            <Shortcut
                              sx={{ color: "#004A92", fontWeight: 700 }}
                            />
                          </IconButton>
                        }
                        subheader={
                          "Application Number  : " + row.applicationNum
                        }
                        subheaderTypographyProps={{
                          color: "#004A92",
                          fontWeight: "700",
                        }}
                        sx={{
                          textAlign: "left",
                          padding: "16px 16px 0px 16px !important",
                        }}
                      />
                      <CardContent sx={{}}>
                        <Grid
                          container
                          item
                          direction="column"
                          alignItems="flex-start"
                          justifyContent="flex-start"
                        >
                          <Grid
                            container
                            direction="row"
                            alignItems="flex-start"
                            justifyContent="flex-start"
                          >
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Applicant Name"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.customerName}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">{"Branch"}</Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.branch}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Loan Type"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.loanType}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Sanctioned Loan Amount"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${row.sanctionAmt}`}
                            </Grid>
                            <Grid item xs={7} md={5}>
                              <Typography padding="1px">
                                {"Application Date"}
                              </Typography>
                            </Grid>
                            <Grid item xs={5} md={7}>
                              {` :  ${dayjs(row.applicationDate).format(
                                "DD/MM/YYYY"
                              )}`}
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          item
                          direction="row"
                          alignItems="flex-end"
                          justifyContent="flex-end"
                        >
                          <Typography sx={{ width: "40%" }}>
                            {loadStatus(row.losStatus)}
                          </Typography>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Divider />
                </React.Fragment>
              ))}
              {rows.length === 0 && (
                <NoDataFound
                  message={"No Sanctioned Application Found."}
                  imageStyle={{
                    marginTop:
                      props.accordianOpenState && window.innerHeight < 1000
                        ? "20px"
                        : "20%",
                  }}
                />
              )}
            </Box>
          </Grid>
        </React.Fragment>
      )}
    </>
  );
};
export default SanctionedList;
